<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    let red_1gqo = JSON.parse(
      "[\n" +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["THR","C","相互作用位点"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","标准残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["THR","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["PRO","E","标准残基"],\n' +
        '["THR","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","E","标准残基"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ILE","E","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["THR","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["ILE","E","相互作用位点"],\n' +
        '["VAL","E","标准残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["THR","E","表面残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LEU","E","标准残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["PRO","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["ALA","F","标准残基"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["ILE","F","相互作用位点"],\n' +
        '["VAL","F","标准残基"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["LYS","F","标准残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["PRO","F","相互作用位点"],\n' +
        '["THR","G","标准残基"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["ARG","G","标准残基"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["GLN","G","表面残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["THR","G","标准残基"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["ARG","G","标准残基"],\n' +
        '["ALA","G","标准残基"],\n' +
        '["ASP","G","表面残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","表面残基"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","标准残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["GLN","H","标准残基"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","标准残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["PRO","H","表面残基"],\n' +
        '["VAL","H","相互作用位点"],\n' +
        '["ILE","H","标准残基"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["PRO","H","表面残基"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","表面残基"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["PRO","H","表面残基"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","相互作用位点"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","I","相互作用位点"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","标准残基"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["ALA","I","相互作用位点"],\n' +
        '["ARG","I","表面残基"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["GLN","I","标准残基"],\n' +
        '["THR","I","相互作用位点"],\n' +
        '["PRO","I","相互作用位点"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","标准残基"],\n' +
        '["ALA","I","相互作用位点"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","I","相互作用位点"],\n' +
        '["THR","I","标准残基"],\n' +
        '["PRO","I","相互作用位点"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","I","表面残基"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ARG","J","标准残基"],\n' +
        '["VAL","J","相互作用位点"],\n' +
        '["ILE","J","表面残基"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","J","表面残基"],\n' +
        '["LEU","J","标准残基"],\n' +
        '["ASP","J","相互作用位点"],\n' +
        '["ALA","J","表面残基"],\n' +
        '["ARG","J","标准残基"],\n' +
        '["LYS","J","相互作用位点"],\n' +
        '["GLN","J","表面残基"],\n' +
        '["THR","J","相互作用位点"],\n' +
        '["PRO","J","标准残基"],\n' +
        '["VAL","J","相互作用位点"],\n' +
        '["ILE","J","表面残基"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","J","相互作用位点"],\n' +
        '["ARG","J","表面残基"],\n' +
        '["LYS","J","标准残基"],\n' +
        '["GLN","J","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ARG","K","相互作用位点"],\n' +
        '["ILE","K","标准残基"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["PRO","K","表面残基"],\n' +
        '["THR","K","标准残基"],\n' +
        '["GLN","K","表面残基"],\n' +
        '["LYS","K","表面残基"],\n' +
        '["ARG","K","相互作用位点"],\n' +
        '["ALA","K","标准残基"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["LEU","K","相互作用位点"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["LEU","K","相互作用位点"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["LEU","K","标准残基"],\n' +
        '["ILE","K","相互作用位点"],\n' +
        '["PRO","K","表面残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["PRO","K","表面残基"],\n' +
        '["ALA","K","相互作用位点"],\n' +
        '["ASP","K","标准残基"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ILE","K","相互作用位点"],\n' +
        '["THR","K","相互作用位点"],\n' +
        '["GLN","K","标准残基"],\n' +
        '["LYS","K","相互作用位点"],\n' +
        '["ARG","K","表面残基"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ILE","K","标准残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["PRO","K","表面残基"],\n' +
        '["THR","K","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","相互作用位点"],\n' +
        '["ILE","L","相互作用位点"],\n' +
        '["PRO","L","标准残基"],\n' +
        '["VAL","L","表面残基"],\n' +
        '["PRO","L","相互作用位点"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["GLN","L","标准残基"],\n' +
        '["LYS","L","相互作用位点"],\n' +
        '["ARG","L","标准残基"],\n' +
        '["ALA","L","相互作用位点"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["ILE","L","相互作用位点"],\n' +
        '["VAL","L","表面残基"],\n' +
        '["PRO","L","表面残基"],\n' +
        '["GLN","M","表面残基"],\n' +
        '["LYS","M","相互作用位点"],\n' +
        '["ARG","M","标准残基"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["ARG","M","相互作用位点"],\n' +
        '["LYS","M","表面残基"],\n' +
        '["GLN","M","表面残基"],\n' +
        '["THR","M","标准残基"],\n' +
        '["PRO","M","相互作用位点"],\n' +
        '["VAL","M","相互作用位点"],\n' +
        '["ILE","M","表面残基"],\n' +
        '["LEU","M","标准残基"],\n' +
        '["ASP","M","相互作用位点"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ARG","M","相互作用位点"],\n' +
        '["LYS","M","表面残基"],\n' +
        '["GLN","M","相互作用位点"],\n' +
        '["THR","M","标准残基"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["PRO","M","相互作用位点"],\n' +
        '["VAL","M","表面残基"],\n' +
        '["PRO","M","标准残基"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["LEU","M","相互作用位点"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["ALA","N","表面残基"],\n' +
        '["LEU","N","表面残基"],\n' +
        '["ASP","N","相互作用位点"],\n' +
        '["THR","N","表面残基"],\n' +
        '["PRO","N","表面残基"],\n' +
        '["VAL","N","相互作用位点"],\n' +
        '["ILE","N","标准残基"],\n' +
        '["LEU","N","表面残基"],\n' +
        '["ASP","N","相互作用位点"],\n' +
        '["ALA","N","表面残基"],\n' +
        '["ARG","N","表面残基"],\n' +
        '["LYS","N","相互作用位点"],\n' +
        '["GLN","N","标准残基"],\n' +
        '["THR","N","相互作用位点"],\n' +
        '["ILE","N","相互作用位点"],\n' +
        '["LEU","N","表面残基"],\n' +
        '["ASP","N","标准残基"],\n' +
        '["ALA","N","相互作用位点"],\n' +
        '["PRO","N","表面残基"],\n' +
        '["VAL","N","相互作用位点"],\n' +
        '["PRO","N","表面残基"],\n' +
        '["ILE","N","相互作用位点"],\n' +
        '["LEU","N","标准残基"],\n' +
        '["ASP","O","相互作用位点"],\n' +
        '["ALA","O","表面残基"],\n' +
        '["LEU","O","相互作用位点"],\n' +
        '["ASP","O","表面残基"],\n' +
        '["LEU","O","相互作用位点"],\n' +
        '["ASP","O","表面残基"],\n' +
        '["ALA","O","标准残基"],\n' +
        '["ARG","O","相互作用位点"],\n' +
        '["LYS","O","表面残基"],\n' +
        '["GLN","O","表面残基"],\n' +
        '["THR","O","标准残基"],\n' +
        '["PRO","O","表面残基"],\n' +
        '["VAL","O","相互作用位点"],\n' +
        '["LEU","O","表面残基"],\n' +
        '["ILE","O","标准残基"],\n' +
        '["ARG","O","相互作用位点"],\n' +
        '["ALA","O","表面残基"],\n' +
        '["ASP","O","表面残基"],\n' +
        '["LEU","O","表面残基"],\n' +
        '["GLN","O","相互作用位点"],\n' +
        '["LYS","O","标准残基"],\n' +
        '["ARG","O","表面残基"],\n' +
        '["ALA","O","相互作用位点"],\n' +
        '["ASP","O","表面残基"],\n' +
        '["LEU","O","表面残基"],\n' +
        '["ILE","O","表面残基"],\n' +
        '["VAL","O","相互作用位点"],\n' +
        '["PRO","P","标准残基"],\n' +
        '["THR","P","相互作用位点"],\n' +
        '["GLN","P","表面残基"],\n' +
        '["LYS","P","相互作用位点"],\n' +
        '["ARG","P","标准残基"],\n' +
        '["ALA","P","表面残基"],\n' +
        '["ALA","P","表面残基"],\n' +
        '["ASP","P","表面残基"],\n' +
        '["ILE","P","表面残基"],\n' +
        '["VAL","P","相互作用位点"],\n' +
        '["ARG","P","标准残基"],\n' +
        '["ALA","P","表面残基"],\n' +
        '["ASP","P","相互作用位点"],\n' +
        '["LEU","P","表面残基"],\n' +
        '["ILE","P","表面残基"],\n' +
        '["VAL","P","表面残基"],\n' +
        '["PRO","Q","相互作用位点"],\n' +
        '["THR","Q","标准残基"],\n' +
        '["ILE","Q","相互作用位点"],\n' +
        '["VAL","Q","表面残基"],\n' +
        '["ARG","Q","相互作用位点"],\n' +
        '["ALA","Q","表面残基"],\n' +
        '["ALA","Q","相互作用位点"],\n' +
        '["ASP","Q","标准残基"],\n' +
        '["LEU","Q","表面残基"],\n' +
        '["PRO","Q","相互作用位点"],\n' +
        '["THR","Q","相互作用位点"],\n' +
        '["GLN","Q","标准残基"],\n' +
        '["LYS","Q","表面残基"],\n' +
        '["ARG","Q","表面残基"],\n' +
        '["ALA","Q","相互作用位点"],\n' +
        '["ASP","Q","相互作用位点"],\n' +
        '["LEU","Q","表面残基"],\n' +
        '["GLN","Q","标准残基"],\n' +
        '["LYS","Q","相互作用位点"],\n' +
        '["ARG","Q","标准残基"],\n' +
        '["ALA","Q","相互作用位点"],\n' +
        '["ASP","Q","表面残基"],\n' +
        '["LEU","R","表面残基"],\n' +
        '["ILE","R","相互作用位点"],\n' +
        '["VAL","R","表面残基"],\n' +
        '["PRO","R","表面残基"],\n' +
        '["GLN","R","表面残基"],\n' +
        '["LYS","R","相互作用位点"],\n' +
        '["ARG","R","标准残基"],\n' +
        '["ASP","R","表面残基"],\n' +
        '["LEU","R","相互作用位点"],\n' +
        '["ILE","R","表面残基"],\n' +
        '["VAL","R","表面残基"],\n' +
        '["PRO","R","表面残基"],\n' +
        '["LEU","R","相互作用位点"],\n' +
        '["ILE","R","标准残基"],\n' +
        '["VAL","R","相互作用位点"],\n' +
        '["PRO","R","表面残基"],\n' +
        '["GLN","R","相互作用位点"],\n' +
        '["LYS","R","表面残基"],\n' +
        '["ARG","R","相互作用位点"],\n' +
        '["ALA","R","标准残基"],\n' +
        '["ASP","R","表面残基"],\n' +
        '["ASP","R","相互作用位点"],\n' +
        '["LEU","R","相互作用位点"],\n' +
        '["GLN","R","标准残基"],\n' +
        '["LYS","R","相互作用位点"],\n' +
        '["ARG","R","标准残基"],\n' +
        '["ALA","R","相互作用位点"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["LEU","S","表面残基"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["ALA","S","标准残基"],\n' +
        '["ARG","S","标准残基"],\n' +
        '["LYS","S","相互作用位点"],\n' +
        '["GLN","S","相互作用位点"],\n' +
        '["THR","S","标准残基"],\n' +
        '["LYS","S","相互作用位点"],\n' +
        '["GLN","S","表面残基"],\n' +
        '["LEU","S","表面残基"],\n' +
        '["ASP","S","相互作用位点"],\n' +
        '["ALA","S","表面残基"],\n' +
        '["ARG","S","标准残基"],\n' +
        '["LYS","S","相互作用位点"],\n' +
        '["GLN","S","相互作用位点"],\n' +
        '["THR","S","标准残基"],\n' +
        '["PRO","S","相互作用位点"],\n' +
        '["LYS","S","表面残基"],\n' +
        '["GLN","S","表面残基"],\n' +
        '["LEU","S","相互作用位点"],\n' +
        '["ASP","S","相互作用位点"],\n' +
        '["ALA","S","表面残基"],\n' +
        '["ARG","S","表面残基"],\n' +
        '["LYS","S","标准残基"],\n' +
        '["GLN","S","相互作用位点"],\n' +
        '["THR","S","相互作用位点"],\n' +
        '["PRO","S","表面残基"],\n' +
        '["VAL","S","标准残基"],\n' +
        '["ILE","S","相互作用位点"],\n' +
        '["LEU","S","标准残基"],\n' +
        '["ASP","S","相互作用位点"],\n' +
        '["ALA","S","相互作用位点"],\n' +
        '["ARG","T","标准残基"],\n' +
        '["LYS","T","相互作用位点"],\n' +
        '["GLN","T","表面残基"],\n' +
        '["LEU","T","表面残基"],\n' +
        '["ASP","T","表面残基"],\n' +
        '["ALA","T","标准残基"],\n' +
        '["ARG","T","相互作用位点"],\n' +
        '["LYS","T","相互作用位点"],\n' +
        '["PRO","T","标准残基"],\n' +
        '["VAL","T","相互作用位点"],\n' +
        '["ILE","T","表面残基"],\n' +
        '["LEU","T","表面残基"],\n' +
        '["ASP","T","相互作用位点"],\n' +
        '["ALA","T","表面残基"],\n' +
        '["ARG","T","表面残基"],\n' +
        '["LYS","T","表面残基"],\n' +
        '["GLN","T","相互作用位点"],\n' +
        '["LEU","T","标准残基"],\n' +
        '["ARG","T","表面残基"],\n' +
        '["LYS","T","相互作用位点"],\n' +
        '["GLN","U","相互作用位点"],\n' +
        '["THR","U","表面残基"],\n' +
        '["PRO","U","表面残基"],\n' +
        '["VAL","U","标准残基"],\n' +
        '["ILE","U","相互作用位点"],\n' +
        '["ASP","U","相互作用位点"],\n' +
        '["ALA","U","表面残基"],\n' +
        '["ARG","U","标准残基"],\n' +
        '["LYS","U","相互作用位点"],\n' +
        '["GLN","U","表面残基"],\n' +
        '["THR","U","相互作用位点"],\n' +
        '["PRO","U","表面残基"],\n' +
        '["VAL","U","相互作用位点"],\n' +
        '["ILE","U","标准残基"],\n' +
        '["LEU","U","相互作用位点"],\n' +
        '["ASP","U","表面残基"],\n' +
        '["ALA","U","表面残基"],\n' +
        '["ARG","U","表面残基"],\n' +
        '["LYS","U","相互作用位点"],\n' +
        '["GLN","U","表面残基"],\n' +
        '["LEU","U","标准残基"],\n' +
        '["ASP","U","相互作用位点"],\n' +
        '["ALA","U","表面残基"],\n' +
        '["ARG","U","标准残基"],\n' +
        '["LYS","U","相互作用位点"],\n' +
        '["GLN","U","表面残基"],\n' +
        '["THR","U","相互作用位点"],\n' +
        '["PRO","U","标准残基"],\n' +
        '["VAL","U","相互作用位点"],\n' +
        '["ILE","U","表面残基"],\n' +
        '["LEU","V","表面残基"],\n' +
        '["ASP","V","相互作用位点"],\n' +
        '["ALA","V","相互作用位点"],\n' +
        '["ARG","V","表面残基"],\n' +
        '["LYS","V","标准残基"],\n' +
        '["GLN","V","相互作用位点"],\n' +
        '["ARG","V","表面残基"],\n' +
        '["LYS","V","相互作用位点"],\n' +
        '["GLN","V","表面残基"],\n' +
        '["PRO","V","相互作用位点"],\n' +
        '["VAL","V","标准残基"],\n' +
        '["VAL","V","相互作用位点"],\n' +
        '["ILE","V","表面残基"],\n' +
        '["LEU","V","相互作用位点"],\n' +
        '["ASP","V","相互作用位点"],\n' +
        '["ALA","V","表面残基"],\n' +
        '["LYS","V","表面残基"],\n' +
        '["GLN","V","标准残基"],\n' +
        '["LEU","V","相互作用位点"],\n' +
        '["ASP","V","相互作用位点"],\n' +
        '["ALA","V","表面残基"],\n' +
        '["ARG","V","标准残基"],\n' +
        '["LYS","V","相互作用位点"],\n' +
        '["GLN","V","相互作用位点"],\n' +
        '["THR","V","表面残基"],\n' +
        '["PRO","V","标准残基"],\n' +
        '["VAL","V","相互作用位点"],\n' +
        '["ILE","V","表面残基"],\n' +
        '["PRO","V","表面残基"],\n' +
        '["VAL","V","相互作用位点"],\n' +
        '["PRO","V","表面残基"],\n' +
        '["ALA","V","相互作用位点"],\n' +
        '["ASP","V","标准残基"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ILE","W","相互作用位点"],\n' +
        '["THR","W","相互作用位点"],\n' +
        '["GLN","W","标准残基"],\n' +
        '["LYS","W","相互作用位点"],\n' +
        '["ARG","W","表面残基"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ILE","W","标准残基"],\n' +
        '["VAL","W","相互作用位点"],\n' +
        '["PRO","W","表面残基"],\n' +
        '["THR","W","表面残基"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["ASP","W","表面残基"],\n' +
        '["LEU","W","相互作用位点"],\n' +
        '["ILE","W","相互作用位点"],\n' +
        '["PRO","W","标准残基"],\n' +
        '["VAL","W","表面残基"],\n' +
        '["PRO","W","相互作用位点"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["ASP","W","表面残基"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ILE","W","相互作用位点"],\n' +
        '["THR","W","标准残基"],\n' +
        '["GLN","W","相互作用位点"],\n' +
        '["LYS","W","表面残基"],\n' +
        '["ARG","W","相互作用位点"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["LEU","W","标准残基"],\n' +
        '["ILE","W","表面残基"],\n' +
        '["VAL","W","相互作用位点"],\n' +
        '["ARG","W","标准残基"],\n' +
        '["LYS","X","相互作用位点"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["LEU","X","标准残基"],\n' +
        '["ASP","X","相互作用位点"],\n' +
        '["ALA","X","相互作用位点"],\n' +
        '["ARG","X","表面残基"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["THR","X","表面残基"],\n' +
        '["PRO","X","相互作用位点"],\n' +
        '["VAL","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","表面残基"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["LEU","X","标准残基"],\n' +
        '["ASP","X","相互作用位点"],\n' +
        '["ALA","X","相互作用位点"],\n' +
        '["ARG","X","表面残基"],\n' +
        '["ARG","X","标准残基"],\n' +
        '["LYS","X","相互作用位点"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["PRO","X","相互作用位点"],\n' +
        '["VAL","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["LEU","X","表面残基"],\n' +
        '["ASP","X","表面残基"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","表面残基"],\n' +
        '["ARG","X","标准残基"],\n' +
        '["LYS","X","相互作用位点"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["THR","X","相互作用位点"],\n' +
        '["PRO","X","表面残基"],\n' +
        '["VAL","X","相互作用位点"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["LEU","X","表面残基"],\n' +
        '["ASP","X","表面残基"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ARG","Y","相互作用位点"],\n' +
        '["LYS","Y","表面残基"],\n' +
        '["GLN","Y","标准残基"],\n' +
        '["THR","Y","相互作用位点"],\n' +
        '["PRO","Y","相互作用位点"],\n' +
        '["VAL","Y","标准残基"],\n' +
        '["ILE","Y","表面残基"],\n' +
        '["ILE","Y","表面残基"],\n' +
        '["VAL","Y","相互作用位点"],\n' +
        '["PRO","Y","标准残基"],\n' +
        '["THR","Y","相互作用位点"],\n' +
        '["GLN","Y","表面残基"],\n' +
        '["LYS","Y","相互作用位点"],\n' +
        '["ARG","Y","标准残基"],\n' +
        '["ALA","Y","表面残基"],\n' +
        '["ASP","Y","相互作用位点"],\n' +
        '["LEU","Y","标准残基"],\n' +
        '["ALA","Y","表面残基"],\n' +
        '["ASP","Y","表面残基"],\n' +
        '["ILE","Y","表面残基"],\n' +
        '["VAL","Y","相互作用位点"],\n' +
        '["ARG","Y","标准残基"],\n' +
        '["ALA","Y","表面残基"],\n' +
        '["ASP","Y","相互作用位点"],\n' +
        '["LEU","Y","表面残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_1gqo", JSON.stringify(red_1gqo));
    let res_2iwv = JSON.parse(
      "[\n" +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","标准残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["ASP","B","标准残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ASP","D","标准残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","标准残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_2iwv", JSON.stringify(res_2iwv));
    let red_2pkr = JSON.parse(
      "[\n" +
        '["GLN","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["PRO","C","相互作用位点"],\n' +
        '["THR","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["LYS","C","标准残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["THR","D","表面残基"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["THR","E","相互作用位点"],\n' +
        '["ILE","E","相互作用位点"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","标准残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["PRO","E","标准残基"],\n' +
        '["THR","E","表面残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["LYS","E","表面残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["VAL","E","标准残基"],\n' +
        '["PRO","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["LYS","F","标准残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["PRO","F","标准残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ILE","F","标准残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ILE","G","相互作用位点"],\n' +
        '["VAL","G","标准残基"],\n' +
        '["PRO","G","表面残基"],\n' +
        '["THR","G","表面残基"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LEU","G","标准残基"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ILE","G","表面残基"],\n' +
        '["VAL","G","相互作用位点"],\n' +
        '["PRO","G","标准残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["ARG","G","相互作用位点"],\n' +
        '["ALA","H","标准残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["ALA","H","相互作用位点"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["LEU","H","标准残基"],\n' +
        '["ILE","H","相互作用位点"],\n' +
        '["VAL","H","标准残基"],\n' +
        '["PRO","H","表面残基"],\n' +
        '["THR","H","相互作用位点"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["LYS","H","标准残基"],\n' +
        '["ARG","H","表面残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["PRO","H","相互作用位点"],\n' +
        '["THR","H","标准残基"],\n' +
        '["GLN","I","相互作用位点"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["GLN","I","表面残基"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["THR","I","标准残基"],\n' +
        '["GLN","I","相互作用位点"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["ALA","I","标准残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","相互作用位点"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","标准残基"],\n' +
        '["LEU","I","相互作用位点"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","标准残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["GLN","J","相互作用位点"],\n' +
        '["PRO","J","表面残基"],\n' +
        '["VAL","J","相互作用位点"],\n' +
        '["ILE","J","标准残基"],\n' +
        '["LEU","J","相互作用位点"],\n' +
        '["PRO","J","表面残基"],\n' +
        '["VAL","J","表面残基"],\n' +
        '["ILE","J","表面残基"],\n' +
        '["LEU","J","相互作用位点"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ARG","J","标准残基"],\n' +
        '["LYS","J","相互作用位点"],\n' +
        '["GLN","J","表面残基"],\n' +
        '["PRO","J","表面残基"],\n' +
        '["VAL","J","表面残基"],\n' +
        '["ILE","J","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","J","相互作用位点"],\n' +
        '["ARG","J","标准残基"],\n' +
        '["LYS","J","相互作用位点"],\n' +
        '["GLN","J","标准残基"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["ALA","K","相互作用位点"],\n' +
        '["ARG","K","表面残基"],\n' +
        '["LYS","K","表面残基"],\n' +
        '["GLN","K","标准残基"],\n' +
        '["THR","K","相互作用位点"],\n' +
        '["PRO","K","相互作用位点"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","标准残基"],\n' +
        '["ALA","K","相互作用位点"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ARG","K","相互作用位点"],\n' +
        '["VAL","K","表面残基"],\n' +
        '["ILE","K","相互作用位点"],\n' +
        '["THR","K","标准残基"],\n' +
        '["PRO","K","相互作用位点"],\n' +
        '["VAL","K","表面残基"],\n' +
        '["ILE","K","表面残基"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ARG","K","标准残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["ILE","K","表面残基"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["LEU","K","标准残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ARG","L","标准残基"],\n' +
        '["LYS","L","相互作用位点"],\n' +
        '["GLN","L","表面残基"],\n' +
        '["THR","L","相互作用位点"],\n' +
        '["PRO","L","标准残基"],\n' +
        '["VAL","L","相互作用位点"],\n' +
        '["ILE","L","表面残基"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["ALA","L","相互作用位点"],\n' +
        '["ARG","L","表面残基"],\n' +
        '["LYS","L","标准残基"],\n' +
        '["GLN","L","相互作用位点"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ARG","L","相互作用位点"],\n' +
        '["ILE","L","标准残基"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["VAL","L","相互作用位点"],\n' +
        '["PRO","L","表面残基"],\n' +
        '["THR","L","标准残基"],\n' +
        '["GLN","L","表面残基"],\n' +
        '["LYS","L","表面残基"],\n' +
        '["ARG","L","相互作用位点"],\n' +
        '["ALA","L","标准残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","相互作用位点"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","相互作用位点"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ASP","L","相互作用位点"],\n' +
        '["LEU","M","标准残基"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["PRO","M","表面残基"],\n' +
        '["VAL","M","相互作用位点"],\n' +
        '["PRO","M","表面残基"],\n' +
        '["ALA","M","相互作用位点"],\n' +
        '["ASP","M","标准残基"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["THR","M","相互作用位点"],\n' +
        '["GLN","M","标准残基"],\n' +
        '["LYS","M","相互作用位点"],\n' +
        '["ARG","M","表面残基"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","相互作用位点"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ILE","M","标准残基"],\n' +
        '["VAL","M","相互作用位点"],\n' +
        '["PRO","M","表面残基"],\n' +
        '["THR","M","表面残基"],\n' +
        '["ASP","M","相互作用位点"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["LEU","M","相互作用位点"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["PRO","M","标准残基"],\n' +
        '["VAL","M","表面残基"],\n' +
        '["PRO","M","相互作用位点"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["THR","M","标准残基"],\n' +
        '["GLN","M","相互作用位点"],\n' +
        '["LYS","M","表面残基"],\n' +
        '["ARG","M","相互作用位点"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","相互作用位点"],\n' +
        '["LEU","M","标准残基"],\n' +
        '["ILE","M","表面残基"],\n' +
        '["VAL","M","相互作用位点"],\n' +
        '["PRO","M","相互作用位点"],\n' +
        '["THR","M","标准残基"],\n' +
        '["GLN","M","表面残基"],\n' +
        '["LYS","M","表面残基"],\n' +
        '["ARG","M","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_2pkr", JSON.stringify(red_2pkr));
    let red_3a2o = JSON.parse(
      "[\n" +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","标准残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3a2o", JSON.stringify(red_3a2o));
    let red_3efz = JSON.parse(
      "[\n" +
        '["GLN","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","标准残基"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ASP","C","标准残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","标准残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["THR","D","表面残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3efz", JSON.stringify(red_3efz));
    let red_3eu8 = JSON.parse(
      "[\n" +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["THR","A","标准残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","标准残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["PRO","C","相互作用位点"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["VAL","C","标准残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","表面残基"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3eu8", JSON.stringify(red_3eu8));
    let red_3fnu = JSON.parse(
      "[\n" +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","标准残基"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","标准残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ASP","D","标准残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["THR","D","表面残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3fnu", JSON.stringify(red_3fnu));
    let red_3lix = JSON.parse(
      "[\n" +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["THR","A","标准残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["PRO","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","标准残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","标准残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3lix", JSON.stringify(red_3lix));
    let red_3mi0 = JSON.parse(
      "[\n" +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","标准残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","标准残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["PRO","C","相互作用位点"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["PRO","C","标准残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["THR","D","表面残基"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","标准残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["THR","D","表面残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["LYS","E","表面残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["VAL","E","标准残基"],\n' +
        '["PRO","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["PRO","E","标准残基"],\n' +
        '["THR","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ILE","F","标准残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ILE","F","相互作用位点"],\n' +
        '["VAL","F","标准残基"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["THR","F","表面残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ILE","G","表面残基"],\n' +
        '["VAL","G","相互作用位点"],\n' +
        '["PRO","G","标准残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["ARG","G","相互作用位点"],\n' +
        '["ALA","G","标准残基"],\n' +
        '["ASP","G","表面残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["GLN","G","表面残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["ARG","G","标准残基"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["LEU","G","标准残基"],\n' +
        '["ILE","G","相互作用位点"],\n' +
        '["VAL","G","标准残基"],\n' +
        '["PRO","G","表面残基"],\n' +
        '["THR","G","相互作用位点"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["LYS","G","标准残基"],\n' +
        '["ARG","H","表面残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["PRO","H","相互作用位点"],\n' +
        '["THR","H","标准残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["THR","H","标准残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["ALA","H","标准残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","相互作用位点"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","标准残基"],\n' +
        '["LEU","I","相互作用位点"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","标准残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["GLN","I","相互作用位点"],\n' +
        '["PRO","I","表面残基"],\n' +
        '["VAL","I","相互作用位点"],\n' +
        '["ILE","I","标准残基"],\n' +
        '["LEU","I","相互作用位点"],\n' +
        '["PRO","I","表面残基"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","I","表面残基"],\n' +
        '["LEU","I","相互作用位点"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","表面残基"],\n' +
        '["PRO","I","表面残基"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","J","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","J","相互作用位点"],\n' +
        '["ARG","J","标准残基"],\n' +
        '["LYS","J","相互作用位点"],\n' +
        '["GLN","J","标准残基"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","相互作用位点"],\n' +
        '["ALA","J","相互作用位点"],\n' +
        '["ARG","J","表面残基"],\n' +
        '["LYS","J","表面残基"],\n' +
        '["GLN","J","标准残基"],\n' +
        '["THR","J","相互作用位点"],\n' +
        '["PRO","J","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","标准残基"],\n' +
        '["ALA","J","相互作用位点"],\n' +
        '["ALA","J","表面残基"],\n' +
        '["ARG","J","相互作用位点"],\n' +
        '["VAL","J","表面残基"],\n' +
        '["ILE","J","相互作用位点"],\n' +
        '["THR","J","标准残基"],\n' +
        '["PRO","K","相互作用位点"],\n' +
        '["VAL","K","表面残基"],\n' +
        '["ILE","K","表面残基"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ARG","K","标准残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["ILE","K","表面残基"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["LEU","K","标准残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ARG","K","标准残基"],\n' +
        '["LYS","K","相互作用位点"],\n' +
        '["GLN","K","表面残基"],\n' +
        '["THR","K","相互作用位点"],\n' +
        '["PRO","K","标准残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["ILE","K","表面残基"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["ALA","K","相互作用位点"],\n' +
        '["ARG","K","表面残基"],\n' +
        '["LYS","K","标准残基"],\n' +
        '["GLN","K","相互作用位点"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["ALA","K","表面残基"],\n' +
        '["ARG","K","相互作用位点"],\n' +
        '["ILE","K","标准残基"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["VAL","K","相互作用位点"],\n' +
        '["PRO","K","表面残基"],\n' +
        '["THR","K","标准残基"],\n' +
        '["GLN","K","表面残基"],\n' +
        '["LYS","K","表面残基"],\n' +
        '["ARG","K","相互作用位点"],\n' +
        '["ALA","K","标准残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","相互作用位点"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["LEU","L","相互作用位点"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ASP","L","相互作用位点"],\n' +
        '["LEU","L","标准残基"],\n' +
        '["ILE","L","相互作用位点"],\n' +
        '["PRO","L","表面残基"],\n' +
        '["VAL","L","相互作用位点"],\n' +
        '["PRO","L","表面残基"],\n' +
        '["ALA","L","相互作用位点"],\n' +
        '["ASP","L","标准残基"],\n' +
        '["LEU","L","表面残基"],\n' +
        '["ILE","L","相互作用位点"],\n' +
        '["THR","L","相互作用位点"],\n' +
        '["GLN","L","标准残基"],\n' +
        '["LYS","L","相互作用位点"],\n' +
        '["ARG","L","表面残基"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ASP","L","相互作用位点"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ILE","M","标准残基"],\n' +
        '["VAL","M","相互作用位点"],\n' +
        '["PRO","M","表面残基"],\n' +
        '["THR","M","表面残基"],\n' +
        '["ASP","M","相互作用位点"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["LEU","M","相互作用位点"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["PRO","M","标准残基"],\n' +
        '["VAL","M","表面残基"],\n' +
        '["PRO","M","相互作用位点"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","表面残基"],\n' +
        '["LEU","M","表面残基"],\n' +
        '["ILE","M","相互作用位点"],\n' +
        '["THR","M","标准残基"],\n' +
        '["GLN","M","相互作用位点"],\n' +
        '["LYS","M","表面残基"],\n' +
        '["ARG","M","相互作用位点"],\n' +
        '["ALA","M","表面残基"],\n' +
        '["ASP","M","相互作用位点"],\n' +
        '["LEU","M","标准残基"],\n' +
        '["ILE","M","表面残基"],\n' +
        '["VAL","M","相互作用位点"],\n' +
        '["PRO","M","相互作用位点"],\n' +
        '["THR","N","标准残基"],\n' +
        '["GLN","N","表面残基"],\n' +
        '["LYS","N","表面残基"],\n' +
        '["ARG","N","相互作用位点"],\n' +
        '["ASP","N","表面残基"],\n' +
        '["ARG","N","标准残基"],\n' +
        '["LYS","N","相互作用位点"],\n' +
        '["GLN","N","表面残基"],\n' +
        '["PRO","N","表面残基"],\n' +
        '["VAL","N","表面残基"],\n' +
        '["ILE","N","相互作用位点"],\n' +
        '["LEU","N","表面残基"],\n' +
        '["ASP","N","表面残基"],\n' +
        '["ALA","N","相互作用位点"],\n' +
        '["ARG","N","标准残基"],\n' +
        '["LYS","N","相互作用位点"],\n' +
        '["GLN","N","标准残基"],\n' +
        '["LEU","N","表面残基"],\n' +
        '["LEU","N","表面残基"],\n' +
        '["ASP","N","表面残基"],\n' +
        '["ALA","N","表面残基"],\n' +
        '["PRO","N","相互作用位点"],\n' +
        '["VAL","N","表面残基"],\n' +
        '["PRO","O","标准残基"],\n' +
        '["ILE","O","相互作用位点"],\n' +
        '["LEU","O","相互作用位点"],\n' +
        '["ASP","O","表面残基"],\n' +
        '["ALA","O","表面残基"],\n' +
        '["LEU","O","表面残基"],\n' +
        '["ASP","O","相互作用位点"],\n' +
        '["THR","O","表面残基"],\n' +
        '["PRO","O","表面残基"],\n' +
        '["VAL","O","相互作用位点"],\n' +
        '["ILE","O","标准残基"],\n' +
        '["LEU","O","表面残基"],\n' +
        '["ASP","O","相互作用位点"],\n' +
        '["ALA","O","表面残基"],\n' +
        '["ARG","O","表面残基"],\n' +
        '["LYS","O","相互作用位点"],\n' +
        '["GLN","O","标准残基"],\n' +
        '["THR","O","相互作用位点"],\n' +
        '["ILE","O","相互作用位点"],\n' +
        '["LEU","O","表面残基"],\n' +
        '["ASP","O","标准残基"],\n' +
        '["ALA","O","相互作用位点"],\n' +
        '["PRO","O","表面残基"],\n' +
        '["VAL","O","相互作用位点"],\n' +
        '["PRO","O","表面残基"],\n' +
        '["ILE","O","相互作用位点"],\n' +
        '["LEU","O","标准残基"],\n' +
        '["ASP","P","相互作用位点"],\n' +
        '["ALA","P","表面残基"],\n' +
        '["LEU","P","相互作用位点"],\n' +
        '["ASP","P","表面残基"],\n' +
        '["LEU","P","相互作用位点"],\n' +
        '["ASP","P","表面残基"],\n' +
        '["ALA","P","标准残基"],\n' +
        '["ARG","P","相互作用位点"],\n' +
        '["LYS","P","表面残基"],\n' +
        '["GLN","P","表面残基"],\n' +
        '["THR","P","标准残基"],\n' +
        '["PRO","P","表面残基"],\n' +
        '["VAL","P","相互作用位点"],\n' +
        '["LEU","P","表面残基"],\n' +
        '["ILE","P","标准残基"],\n' +
        '["ARG","P","相互作用位点"],\n' +
        '["ALA","Q","表面残基"],\n' +
        '["ASP","Q","表面残基"],\n' +
        '["LEU","Q","表面残基"],\n' +
        '["GLN","Q","相互作用位点"],\n' +
        '["LYS","Q","标准残基"],\n' +
        '["ARG","Q","表面残基"],\n' +
        '["ALA","Q","相互作用位点"],\n' +
        '["ASP","Q","表面残基"],\n' +
        '["LEU","Q","表面残基"],\n' +
        '["ILE","Q","表面残基"],\n' +
        '["VAL","Q","相互作用位点"],\n' +
        '["PRO","Q","标准残基"],\n' +
        '["THR","Q","相互作用位点"],\n' +
        '["GLN","Q","表面残基"],\n' +
        '["LYS","Q","相互作用位点"],\n' +
        '["ARG","Q","标准残基"],\n' +
        '["ALA","Q","表面残基"],\n' +
        '["ASP","Q","相互作用位点"],\n' +
        '["LEU","Q","标准残基"],\n' +
        '["ALA","Q","表面残基"],\n' +
        '["ASP","Q","表面残基"],\n' +
        '["ILE","Q","表面残基"],\n' +
        '["VAL","R","相互作用位点"],\n' +
        '["ARG","R","标准残基"],\n' +
        '["ALA","R","表面残基"],\n' +
        '["ASP","R","相互作用位点"],\n' +
        '["LEU","R","表面残基"],\n' +
        '["ILE","R","表面残基"],\n' +
        '["VAL","R","表面残基"],\n' +
        '["PRO","R","相互作用位点"],\n' +
        '["THR","R","标准残基"],\n' +
        '["ILE","R","相互作用位点"],\n' +
        '["VAL","R","表面残基"],\n' +
        '["ARG","R","相互作用位点"],\n' +
        '["ALA","R","表面残基"],\n' +
        '["ALA","R","相互作用位点"],\n' +
        '["ASP","R","标准残基"],\n' +
        '["LEU","R","表面残基"],\n' +
        '["PRO","R","相互作用位点"],\n' +
        '["THR","R","相互作用位点"],\n' +
        '["GLN","R","标准残基"],\n' +
        '["LYS","R","表面残基"],\n' +
        '["ARG","R","表面残基"],\n' +
        '["ALA","R","相互作用位点"],\n' +
        '["ASP","R","相互作用位点"],\n' +
        '["LEU","R","表面残基"],\n' +
        '["GLN","R","标准残基"],\n' +
        '["LYS","R","相互作用位点"],\n' +
        '["ARG","R","标准残基"],\n' +
        '["ALA","S","相互作用位点"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["LEU","S","表面残基"],\n' +
        '["ILE","S","相互作用位点"],\n' +
        '["VAL","S","表面残基"],\n' +
        '["PRO","S","表面残基"],\n' +
        '["GLN","S","表面残基"],\n' +
        '["LYS","S","相互作用位点"],\n' +
        '["ARG","S","标准残基"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["LEU","S","相互作用位点"],\n' +
        '["ILE","S","表面残基"],\n' +
        '["VAL","S","表面残基"],\n' +
        '["PRO","S","表面残基"],\n' +
        '["LEU","S","相互作用位点"],\n' +
        '["ILE","S","标准残基"],\n' +
        '["VAL","S","相互作用位点"],\n' +
        '["PRO","S","表面残基"],\n' +
        '["GLN","S","相互作用位点"],\n' +
        '["LYS","S","表面残基"],\n' +
        '["ARG","S","相互作用位点"],\n' +
        '["ALA","S","标准残基"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["ASP","S","相互作用位点"],\n' +
        '["LEU","S","相互作用位点"],\n' +
        '["GLN","S","标准残基"],\n' +
        '["LYS","S","相互作用位点"],\n' +
        '["ARG","S","标准残基"],\n' +
        '["ALA","S","相互作用位点"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["LEU","S","表面残基"],\n' +
        '["ASP","S","表面残基"],\n' +
        '["ALA","S","标准残基"],\n' +
        '["ARG","S","标准残基"],\n' +
        '["LYS","S","相互作用位点"],\n' +
        '["GLN","T","相互作用位点"],\n' +
        '["THR","T","标准残基"],\n' +
        '["LYS","T","相互作用位点"],\n' +
        '["GLN","T","表面残基"],\n' +
        '["LEU","T","表面残基"],\n' +
        '["ASP","T","相互作用位点"],\n' +
        '["ALA","T","表面残基"],\n' +
        '["ARG","T","标准残基"],\n' +
        '["LYS","T","相互作用位点"],\n' +
        '["GLN","T","相互作用位点"],\n' +
        '["THR","T","标准残基"],\n' +
        '["PRO","T","相互作用位点"],\n' +
        '["LYS","T","表面残基"],\n' +
        '["GLN","T","表面残基"],\n' +
        '["LEU","T","相互作用位点"],\n' +
        '["ASP","T","相互作用位点"],\n' +
        '["ALA","T","表面残基"],\n' +
        '["ARG","T","表面残基"],\n' +
        '["LYS","T","标准残基"],\n' +
        '["GLN","T","相互作用位点"],\n' +
        '["THR","U","相互作用位点"],\n' +
        '["PRO","U","表面残基"],\n' +
        '["VAL","U","标准残基"],\n' +
        '["ILE","U","相互作用位点"],\n' +
        '["LEU","U","标准残基"],\n' +
        '["ASP","U","相互作用位点"],\n' +
        '["ALA","U","相互作用位点"],\n' +
        '["ARG","U","标准残基"],\n' +
        '["LYS","U","相互作用位点"],\n' +
        '["GLN","U","表面残基"],\n' +
        '["LEU","U","表面残基"],\n' +
        '["ASP","U","表面残基"],\n' +
        '["ALA","U","标准残基"],\n' +
        '["ARG","U","相互作用位点"],\n' +
        '["LYS","U","相互作用位点"],\n' +
        '["PRO","U","标准残基"],\n' +
        '["VAL","U","相互作用位点"],\n' +
        '["ILE","U","表面残基"],\n' +
        '["LEU","U","表面残基"],\n' +
        '["ASP","U","相互作用位点"],\n' +
        '["ALA","U","表面残基"],\n' +
        '["ARG","U","表面残基"],\n' +
        '["LYS","U","表面残基"],\n' +
        '["GLN","U","相互作用位点"],\n' +
        '["LEU","U","标准残基"],\n' +
        '["ARG","U","表面残基"],\n' +
        '["LYS","U","相互作用位点"],\n' +
        '["GLN","U","相互作用位点"],\n' +
        '["THR","U","表面残基"],\n' +
        '["PRO","U","表面残基"],\n' +
        '["VAL","U","标准残基"],\n' +
        '["ILE","U","相互作用位点"],\n' +
        '["ASP","V","相互作用位点"],\n' +
        '["ALA","V","表面残基"],\n' +
        '["ARG","V","标准残基"],\n' +
        '["LYS","V","相互作用位点"],\n' +
        '["GLN","V","表面残基"],\n' +
        '["THR","V","相互作用位点"],\n' +
        '["PRO","V","表面残基"],\n' +
        '["VAL","V","相互作用位点"],\n' +
        '["ILE","V","标准残基"],\n' +
        '["LEU","V","相互作用位点"],\n' +
        '["ASP","V","表面残基"],\n' +
        '["ALA","V","表面残基"],\n' +
        '["ARG","V","表面残基"],\n' +
        '["LYS","V","相互作用位点"],\n' +
        '["GLN","V","表面残基"],\n' +
        '["LEU","V","标准残基"],\n' +
        '["ASP","V","相互作用位点"],\n' +
        '["ALA","V","表面残基"],\n' +
        '["ARG","V","标准残基"],\n' +
        '["LYS","V","相互作用位点"],\n' +
        '["GLN","V","表面残基"],\n' +
        '["THR","V","相互作用位点"],\n' +
        '["PRO","V","标准残基"],\n' +
        '["VAL","V","相互作用位点"],\n' +
        '["ILE","V","表面残基"],\n' +
        '["LEU","V","表面残基"],\n' +
        '["ASP","V","相互作用位点"],\n' +
        '["ALA","V","相互作用位点"],\n' +
        '["ARG","V","表面残基"],\n' +
        '["LYS","V","标准残基"],\n' +
        '["GLN","V","相互作用位点"],\n' +
        '["ARG","V","表面残基"],\n' +
        '["LYS","V","相互作用位点"],\n' +
        '["GLN","W","表面残基"],\n' +
        '["PRO","W","相互作用位点"],\n' +
        '["VAL","W","标准残基"],\n' +
        '["VAL","W","相互作用位点"],\n' +
        '["ILE","W","表面残基"],\n' +
        '["LEU","W","相互作用位点"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["LYS","W","表面残基"],\n' +
        '["GLN","W","标准残基"],\n' +
        '["LEU","W","相互作用位点"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["ARG","W","标准残基"],\n' +
        '["LYS","W","相互作用位点"],\n' +
        '["GLN","W","相互作用位点"],\n' +
        '["THR","W","表面残基"],\n' +
        '["PRO","W","标准残基"],\n' +
        '["VAL","W","相互作用位点"],\n' +
        '["ILE","W","表面残基"],\n' +
        '["PRO","W","表面残基"],\n' +
        '["VAL","W","相互作用位点"],\n' +
        '["PRO","W","表面残基"],\n' +
        '["ALA","W","相互作用位点"],\n' +
        '["ASP","W","标准残基"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ILE","W","相互作用位点"],\n' +
        '["THR","W","相互作用位点"],\n' +
        '["GLN","W","标准残基"],\n' +
        '["LYS","W","相互作用位点"],\n' +
        '["ARG","W","表面残基"],\n' +
        '["ALA","W","表面残基"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ILE","W","标准残基"],\n' +
        '["VAL","W","相互作用位点"],\n' +
        '["PRO","W","表面残基"],\n' +
        '["THR","W","表面残基"],\n' +
        '["ASP","W","相互作用位点"],\n' +
        '["LEU","W","表面残基"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ASP","X","表面残基"],\n' +
        '["LEU","X","相互作用位点"],\n' +
        '["ILE","X","相互作用位点"],\n' +
        '["PRO","X","标准残基"],\n' +
        '["VAL","X","表面残基"],\n' +
        '["PRO","X","相互作用位点"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ASP","X","表面残基"],\n' +
        '["LEU","X","表面残基"],\n' +
        '["ILE","X","相互作用位点"],\n' +
        '["THR","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["LYS","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ASP","X","相互作用位点"],\n' +
        '["LEU","X","标准残基"],\n' +
        '["ILE","X","表面残基"],\n' +
        '["VAL","X","相互作用位点"],\n' +
        '["ARG","X","标准残基"],\n' +
        '["LYS","X","相互作用位点"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["LEU","X","标准残基"],\n' +
        '["ASP","X","相互作用位点"],\n' +
        '["ALA","X","相互作用位点"],\n' +
        '["ARG","X","表面残基"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["THR","X","表面残基"],\n' +
        '["PRO","X","相互作用位点"],\n' +
        '["VAL","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","表面残基"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["LEU","X","标准残基"],\n' +
        '["ASP","X","相互作用位点"],\n' +
        '["ALA","X","相互作用位点"],\n' +
        '["ARG","X","表面残基"],\n' +
        '["ARG","X","标准残基"],\n' +
        '["LYS","X","相互作用位点"],\n' +
        '["GLN","X","表面残基"],\n' +
        '["PRO","X","相互作用位点"],\n' +
        '["VAL","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["LEU","X","表面残基"],\n' +
        '["ASP","X","表面残基"],\n' +
        '["ALA","X","表面残基"],\n' +
        '["ARG","X","相互作用位点"],\n' +
        '["LYS","X","标准残基"],\n' +
        '["GLN","X","相互作用位点"],\n' +
        '["ARG","Y","相互作用位点"],\n' +
        '["LYS","Y","表面残基"],\n' +
        '["ARG","Y","标准残基"],\n' +
        '["LYS","Y","相互作用位点"],\n' +
        '["GLN","Y","表面残基"],\n' +
        '["THR","Y","相互作用位点"],\n' +
        '["PRO","Y","表面残基"],\n' +
        '["VAL","Y","相互作用位点"],\n' +
        '["ALA","Y","表面残基"],\n' +
        '["ARG","Y","相互作用位点"],\n' +
        '["LYS","Y","标准残基"],\n' +
        '["GLN","Y","相互作用位点"],\n' +
        '["LEU","Y","表面残基"],\n' +
        '["ASP","Y","表面残基"],\n' +
        '["ALA","Y","表面残基"],\n' +
        '["ARG","Y","相互作用位点"],\n' +
        '["LYS","Y","表面残基"],\n' +
        '["GLN","Y","标准残基"],\n' +
        '["THR","Y","相互作用位点"],\n' +
        '["PRO","Y","相互作用位点"],\n' +
        '["VAL","Z","标准残基"],\n' +
        '["ILE","Z","表面残基"],\n' +
        '["LEU","Z","相互作用位点"],\n' +
        '["ASP","Z","相互作用位点"],\n' +
        '["LEU","Z","表面残基"],\n' +
        '["ASP","Z","表面残基"],\n' +
        '["ALA","Z","标准残基"],\n' +
        '["ARG","Z","相互作用位点"],\n' +
        '["LYS","Z","相互作用位点"],\n' +
        '["GLN","Z","表面残基"],\n' +
        '["THR","Z","标准残基"],\n' +
        '["PRO","Z","相互作用位点"],\n' +
        '["VAL","Z","表面残基"],\n' +
        '["ILE","Z","相互作用位点"],\n' +
        '["LEU","Z","表面残基"],\n' +
        '["ASP","Z","相互作用位点"],\n' +
        '["ALA","Z","标准残基"],\n' +
        '["ARG","Z","相互作用位点"],\n' +
        '["LYS","Z","表面残基"],\n' +
        '["ARG","Z","表面残基"],\n' +
        '["LYS","Z","表面残基"],\n' +
        '["GLN","Z","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3mi0", JSON.stringify(red_3mi0));
    let red_3pfd = JSON.parse(
      "[\n" +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","表面残基"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","标准残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","标准残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","标准残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3pfd", JSON.stringify(red_3pfd));
    let red_3qs1 = JSON.parse(
      "[\n" +
        '["LEU","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ASP","D","标准残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3qs1", JSON.stringify(red_3qs1));
    let red_3qvi = JSON.parse(
      "[\n" +
        '["ASP","A","相互作用位点"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["ASP","B","标准残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","标准残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","标准残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","标准残基"],\n' +
        '["GLN","D","标准残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3qvi", JSON.stringify(red_3qvi));
    let red_3r90 = JSON.parse(
      "[\n" +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","标准残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","标准残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","表面残基"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","相互作用位点"],\n' +
        '["LEU","G","标准残基"],\n' +
        '["ASP","G","表面残基"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["THR","G","相互作用位点"],\n' +
        '["PRO","G","相互作用位点"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","标准残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["THR","H","标准残基"],\n' +
        '["PRO","H","相互作用位点"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","相互作用位点"],\n' +
        '["ARG","H","表面残基"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["THR","H","标准残基"],\n' +
        '["PRO","I","表面残基"],\n' +
        '["VAL","I","相互作用位点"],\n' +
        '["ILE","I","相互作用位点"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","标准残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","表面残基"],\n' +
        '["ARG","I","标准残基"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","表面残基"],\n' +
        '["PRO","I","相互作用位点"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","I","相互作用位点"],\n' +
        '["LEU","I","标准残基"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ARG","I","表面残基"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ARG","J","相互作用位点"],\n' +
        '["LYS","J","表面残基"],\n' +
        '["GLN","J","标准残基"],\n' +
        '["ARG","J","相互作用位点"],\n' +
        '["LYS","J","相互作用位点"],\n' +
        '["GLN","J","相互作用位点"],\n' +
        '["PRO","J","表面残基"],\n' +
        '["VAL","J","标准残基"],\n' +
        '["ILE","J","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","相互作用位点"],\n' +
        '["ALA","J","表面残基"],\n' +
        '["ARG","J","相互作用位点"],\n' +
        '["LYS","J","标准残基"],\n' +
        '["GLN","J","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","J","表面残基"],\n' +
        '["ARG","J","相互作用位点"],\n' +
        '["LYS","J","表面残基"],\n' +
        '["GLN","K","标准残基"],\n' +
        '["THR","K","相互作用位点"],\n' +
        '["PRO","K","相互作用位点"],\n' +
        '["VAL","K","标准残基"],\n' +
        '["ILE","K","表面残基"],\n' +
        '["LEU","K","相互作用位点"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","表面残基"],\n' +
        '["ALA","K","标准残基"],\n' +
        '["ARG","K","相互作用位点"],\n' +
        '["LYS","K","相互作用位点"],\n' +
        '["GLN","K","表面残基"],\n' +
        '["THR","K","标准残基"],\n' +
        '["PRO","K","相互作用位点"],\n' +
        '["VAL","K","表面残基"],\n' +
        '["ILE","K","相互作用位点"],\n' +
        '["LEU","K","表面残基"],\n' +
        '["ASP","K","相互作用位点"],\n' +
        '["ALA","K","标准残基"],\n' +
        '["ARG","L","相互作用位点"],\n' +
        '["LYS","L","表面残基"],\n' +
        '["GLN","L","表面残基"],\n' +
        '["ARG","L","表面残基"],\n' +
        '["LYS","L","相互作用位点"],\n' +
        '["GLN","L","表面残基"],\n' +
        '["PRO","L","标准残基"],\n' +
        '["VAL","L","相互作用位点"],\n' +
        '["ILE","L","表面残基"],\n' +
        '["LEU","L","标准残基"],\n' +
        '["ASP","L","表面残基"],\n' +
        '["ALA","L","表面残基"],\n' +
        '["ARG","L","相互作用位点"],\n' +
        '["ALA","L","标准残基"],\n' +
        '["ARG","L","表面残基"],\n' +
        '["LYS","L","相互作用位点"],\n' +
        '["GLN","L","相互作用位点"],\n' +
        '["ARG","L","表面残基"],\n' +
        '["LYS","L","表面残基"],\n' +
        '["GLN","L","标准残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_3r90", JSON.stringify(red_3r90));
    let red_4gyz = JSON.parse(
      "[\n" +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["PRO","C","标准残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","标准残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["PRO","E","相互作用位点"],\n' +
        '["VAL","E","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["LYS","E","表面残基"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["THR","F","表面残基"],\n' +
        '["PRO","F","标准残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["THR","F","表面残基"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","标准残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["THR","G","相互作用位点"],\n' +
        '["PRO","G","相互作用位点"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","标准残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ARG","G","相互作用位点"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["THR","G","标准残基"],\n' +
        '["PRO","G","相互作用位点"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","表面残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ARG","G","标准残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["GLN","G","表面残基"],\n' +
        '["LEU","G","标准残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","标准残基"],\n' +
        '["GLN","G","相互作用位点"],\n' +
        '["THR","G","表面残基"],\n' +
        '["PRO","G","相互作用位点"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LEU","H","标准残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["ALA","H","相互作用位点"],\n' +
        '["ARG","H","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["PRO","H","相互作用位点"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","标准残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","标准残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["GLN","I","表面残基"],\n' +
        '["THR","I","相互作用位点"],\n' +
        '["PRO","I","表面残基"],\n' +
        '["VAL","I","相互作用位点"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","标准残基"],\n' +
        '["GLN","I","相互作用位点"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","表面残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["GLN","I","标准残基"],\n' +
        '["THR","I","相互作用位点"],\n' +
        '["PRO","I","相互作用位点"],\n' +
        '["VAL","I","标准残基"],\n' +
        '["ILE","I","表面残基"],\n' +
        '["LEU","I","相互作用位点"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","标准残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","相互作用位点"],\n' +
        '["GLN","I","表面残基"],\n' +
        '["THR","I","标准残基"],\n' +
        '["PRO","I","相互作用位点"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","I","相互作用位点"],\n' +
        '["LEU","I","表面残基"],\n' +
        '["ASP","I","相互作用位点"],\n' +
        '["ALA","I","标准残基"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["ARG","I","表面残基"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["GLN","I","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_4gyz", JSON.stringify(red_4gyz));
    let red_4nx0 = JSON.parse(
      "[\n" +
        '["PRO","A","标准残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["THR","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["THR","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","标准残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","标准残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","F","表面残基"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","相互作用位点"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","表面残基"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","标准残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["THR","G","相互作用位点"],\n' +
        '["PRO","G","相互作用位点"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","标准残基"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","相互作用位点"],\n' +
        '["THR","H","标准残基"],\n' +
        '["PRO","H","相互作用位点"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["VAL","H","相互作用位点"],\n' +
        '["ILE","H","表面残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","标准残基"],\n' +
        '["THR","H","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_4nx0", JSON.stringify(red_4nx0));
    let red_4oa5 = JSON.parse(
      "[\n" +
        '["PRO","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LEU","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","标准残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["THR","C","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","表面残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","标准残基"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","标准残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","表面残基"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ILE","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","相互作用位点"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","标准残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","标准残基"],\n' +
        '["ARG","E","相互作用位点"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","表面残基"],\n' +
        '["ILE","E","标准残基"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ARG","E","标准残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","标准残基"],\n' +
        '["ARG","E","相互作用位点"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","标准残基"],\n' +
        '["ILE","E","相互作用位点"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","相互作用位点"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ARG","E","相互作用位点"],\n' +
        '["LYS","E","标准残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["ARG","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["ALA","F","标准残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["PRO","F","相互作用位点"],\n' +
        '["VAL","F","标准残基"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","标准残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LYS","F","标准残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["VAL","F","表面残基"],\n' +
        '["ILE","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ALA","F","标准残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["PRO","F","标准残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["ALA","F","标准残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["PRO","F","相互作用位点"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","表面残基"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ASP","F","标准残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_4oa5", JSON.stringify(red_4oa5));
    let red_4xtn = JSON.parse(
      "[\n" +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","标准残基"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["ILE","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","表面残基"],\n' +
        '["ILE","C","表面残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","标准残基"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["ALA","C","相互作用位点"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","C","标准残基"],\n' +
        '["VAL","C","相互作用位点"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["LEU","C","表面残基"],\n' +
        '["ASP","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["GLN","D","相互作用位点"],\n' +
        '["THR","D","表面残基"],\n' +
        '["PRO","D","相互作用位点"],\n' +
        '["VAL","D","标准残基"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ASP","D","表面残基"],\n' +
        '["ALA","D","标准残基"],\n' +
        '["ARG","D","相互作用位点"],\n' +
        '["LYS","D","表面残基"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["ARG","D","表面残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","相互作用位点"],\n' +
        '["LEU","D","表面残基"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","表面残基"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","标准残基"],\n' +
        '["LEU","E","相互作用位点"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["ALA","E","标准残基"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["ALA","E","表面残基"],\n' +
        '["GLN","E","相互作用位点"],\n' +
        '["THR","E","标准残基"],\n' +
        '["PRO","E","表面残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","相互作用位点"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["ALA","E","标准残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["PRO","F","相互作用位点"],\n' +
        '["VAL","F","表面残基"],\n' +
        '["ILE","F","相互作用位点"],\n' +
        '["LEU","F","标准残基"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["LYS","F","标准残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["LYS","F","标准残基"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","标准残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","表面残基"],\n' +
        '["ILE","F","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","相互作用位点"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["ARG","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["ILE","F","相互作用位点"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","标准残基"],\n' +
        '["ARG","G","相互作用位点"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","表面残基"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["GLN","G","表面残基"],\n' +
        '["PRO","G","标准残基"],\n' +
        '["VAL","G","相互作用位点"],\n' +
        '["ILE","G","表面残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","标准残基"],\n' +
        '["ARG","G","相互作用位点"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","表面残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["THR","H","标准残基"],\n' +
        '["PRO","H","表面残基"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","相互作用位点"],\n' +
        '["LEU","H","标准残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","相互作用位点"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","标准残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["PRO","H","表面残基"],\n' +
        '["VAL","H","表面残基"],\n' +
        '["ILE","H","表面残基"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","标准残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["ALA","H","相互作用位点"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","标准残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","标准残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","标准残基"],\n' +
        '["THR","H","相互作用位点"],\n' +
        '["GLN","I","相互作用位点"],\n' +
        '["LEU","I","标准残基"],\n' +
        '["ASP","I","表面残基"],\n' +
        '["ALA","I","相互作用位点"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["ARG","I","表面残基"],\n' +
        '["LYS","I","标准残基"],\n' +
        '["GLN","I","相互作用位点"],\n' +
        '["ARG","I","相互作用位点"],\n' +
        '["LYS","I","表面残基"],\n' +
        '["GLN","I","标准残基"],\n' +
        '["PRO","I","相互作用位点"],\n' +
        '["VAL","I","表面残基"],\n' +
        '["ILE","I","相互作用位点"],\n' +
        '["LEU","J","表面残基"],\n' +
        '["ASP","J","相互作用位点"],\n' +
        '["ALA","J","标准残基"],\n' +
        '["ARG","J","相互作用位点"],\n' +
        '["ALA","J","表面残基"],\n' +
        '["GLN","J","表面残基"],\n' +
        '["THR","J","表面残基"],\n' +
        '["PRO","J","相互作用位点"],\n' +
        '["VAL","J","表面残基"],\n' +
        '["ILE","J","标准残基"],\n' +
        '["LEU","J","相互作用位点"],\n' +
        '["ASP","J","表面残基"],\n' +
        '["ALA","J","标准残基"],\n' +
        '["ARG","J","表面残基"],\n' +
        '["LYS","J","表面残基"],\n' +
        '["GLN","J","相互作用位点"],\n' +
        '["ARG","J","标准残基"],\n' +
        '["LYS","J","相互作用位点"],\n' +
        '["GLN","J","表面残基"],\n' +
        '["LYS","J","表面残基"],\n' +
        '["THR","J","表面残基"],\n' +
        '["PRO","J","表面残基"],\n' +
        '["VAL","J","标准残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_4xtn", JSON.stringify(red_4xtn));
    let red_4zq0 = JSON.parse(
      "[\n" +
        '["ILE","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["THR","B","相互作用位点"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["ILE","C","标准残基"],\n' +
        '["LEU","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","相互作用位点"],\n' +
        '["LYS","C","表面残基"],\n' +
        '["GLN","C","表面残基"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","C","相互作用位点"],\n' +
        '["ALA","C","标准残基"],\n' +
        '["ARG","C","表面残基"],\n' +
        '["LYS","C","相互作用位点"],\n' +
        '["GLN","C","相互作用位点"],\n' +
        '["THR","C","表面残基"],\n' +
        '["PRO","C","表面残基"],\n' +
        '["VAL","C","标准残基"],\n' +
        '["ILE","C","相互作用位点"],\n' +
        '["ASP","C","相互作用位点"],\n' +
        '["ALA","C","表面残基"],\n' +
        '["ARG","C","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","表面残基"],\n' +
        '["VAL","D","相互作用位点"],\n' +
        '["ILE","D","标准残基"],\n' +
        '["LEU","D","相互作用位点"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["LEU","D","标准残基"],\n' +
        '["ASP","D","相互作用位点"],\n' +
        '["ALA","D","表面残基"],\n' +
        '["ARG","D","标准残基"],\n' +
        '["LYS","D","相互作用位点"],\n' +
        '["GLN","D","表面残基"],\n' +
        '["THR","D","相互作用位点"],\n' +
        '["PRO","D","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","表面残基"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["LYS","E","相互作用位点"],\n' +
        '["GLN","E","表面残基"],\n' +
        '["PRO","E","标准残基"],\n' +
        '["VAL","E","相互作用位点"],\n' +
        '["ILE","E","表面残基"],\n' +
        '["LEU","E","表面残基"],\n' +
        '["ASP","E","表面残基"],\n' +
        '["ALA","E","相互作用位点"],\n' +
        '["ARG","E","表面残基"],\n' +
        '["THR","E","表面残基"],\n' +
        '["PRO","E","标准残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ASP","F","标准残基"],\n' +
        '["LYS","F","相互作用位点"],\n' +
        '["GLN","F","表面残基"],\n' +
        '["THR","F","相互作用位点"],\n' +
        '["PRO","F","表面残基"],\n' +
        '["VAL","F","相互作用位点"],\n' +
        '["ILE","F","标准残基"],\n' +
        '["LEU","F","相互作用位点"],\n' +
        '["ASP","F","表面残基"],\n' +
        '["ALA","F","表面残基"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["GLN","F","相互作用位点"],\n' +
        '["LEU","F","表面残基"],\n' +
        '["ASP","F","标准残基"],\n' +
        '["ALA","F","相互作用位点"],\n' +
        '["ARG","F","相互作用位点"],\n' +
        '["LYS","F","表面残基"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","相互作用位点"],\n' +
        '["LEU","G","标准残基"],\n' +
        '["ASP","G","表面残基"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","相互作用位点"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["LEU","G","表面残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","相互作用位点"],\n' +
        '["ARG","G","表面残基"],\n' +
        '["LYS","G","表面残基"],\n' +
        '["GLN","G","标准残基"],\n' +
        '["THR","G","相互作用位点"],\n' +
        '["PRO","G","相互作用位点"],\n' +
        '["VAL","G","表面残基"],\n' +
        '["ILE","G","标准残基"],\n' +
        '["ASP","G","相互作用位点"],\n' +
        '["ALA","G","表面残基"],\n' +
        '["ARG","H","相互作用位点"],\n' +
        '["ARG","H","表面残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["GLN","H","标准残基"],\n' +
        '["LEU","H","相互作用位点"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","相互作用位点"],\n' +
        '["ALA","H","表面残基"],\n' +
        '["ARG","H","标准残基"],\n' +
        '["LYS","H","相互作用位点"],\n' +
        '["GLN","H","表面残基"],\n' +
        '["LEU","H","表面残基"],\n' +
        '["ASP","H","表面残基"],\n' +
        '["ALA","H","相互作用位点"],\n' +
        '["ARG","H","表面残基"],\n' +
        '["LYS","H","表面残基"],\n' +
        '["GLN","H","相互作用位点"],\n' +
        '["THR","H","标准残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_4zq0", JSON.stringify(red_4zq0));
    let red_5fqe = JSON.parse(
      "[\n" +
        '["THR","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["VAL","A","标准残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","标准残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ARG","A","标准残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["PRO","B","表面残基"],\n' +
        '["THR","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","表面残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","标准残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["VAL","B","相互作用位点"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["THR","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ILE","B","相互作用位点"],\n' +
        '["VAL","B","标准残基"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["VAL","B","表面残基"],\n' +
        '["PRO","B","相互作用位点"],\n' +
        '["ASP","B","相互作用位点"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","标准残基"],\n' +
        '["LYS","B","表面残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["ILE","B","标准残基"],\n' +
        '["ARG","B","相互作用位点"],\n' +
        '["ALA","B","表面残基"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"],\n' +
        '["GLN","B","相互作用位点"],\n' +
        '["LYS","B","标准残基"],\n' +
        '["ARG","B","表面残基"],\n' +
        '["ALA","B","相互作用位点"],\n' +
        '["ASP","B","表面残基"],\n' +
        '["LEU","B","表面残基"]\n' +
        "]"
    );
    window.localStorage.setItem("red_5fqe", JSON.stringify(red_5fqe));
    let red_5yid = JSON.parse(
      "[\n" +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["THR","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","标准残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["ALA","A","相互作用位点"],\n' +
        '["ASP","A","标准残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["THR","A","相互作用位点"],\n' +
        '["GLN","A","标准残基"],\n' +
        '["LYS","A","相互作用位点"],\n' +
        '["ARG","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","标准残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","A","表面残基"],\n' +
        '["THR","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","相互作用位点"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["PRO","A","标准残基"],\n' +
        '["VAL","A","表面残基"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","表面残基"],\n' +
        '["LEU","A","表面残基"],\n' +
        '["ILE","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["GLN","A","相互作用位点"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"],\n' +
        '["ALA","A","表面残基"],\n' +
        '["ASP","A","相互作用位点"],\n' +
        '["LEU","A","标准残基"],\n' +
        '["ILE","A","表面残基"],\n' +
        '["VAL","A","相互作用位点"],\n' +
        '["PRO","A","相互作用位点"],\n' +
        '["THR","A","标准残基"],\n' +
        '["GLN","A","表面残基"],\n' +
        '["LYS","A","表面残基"],\n' +
        '["ARG","A","相互作用位点"]\n' +
        "]"
    );
    window.localStorage.setItem("red_5yid", JSON.stringify(red_5yid));
  }
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
